/**
 * Login Page - Clean Design
 */

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../stores';

export function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const login = useAuthStore((s) => s.login);
    const navigate = useNavigate();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            await login(email, password);
            navigate('/');
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Login failed');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            className="min-h-screen flex items-center justify-center p-4"
            style={{ backgroundColor: 'var(--bg-secondary)' }}
        >
            <div className="w-full max-w-sm">
                {/* Logo */}
                <div className="text-center mb-8">
                    <div
                        className="inline-flex w-14 h-14 rounded-xl items-center justify-center text-white text-xl font-bold mb-4"
                        style={{ backgroundColor: 'var(--accent)' }}
                    >
                        TP
                    </div>
                    <h1 className="text-2xl font-bold" style={{ color: 'var(--text-primary)' }}>
                        TPCMS
                    </h1>
                    <p style={{ color: 'var(--text-muted)' }}>
                        Content Management System
                    </p>
                </div>

                {/* Login Card */}
                <div className="card p-6">
                    <h2 className="text-lg font-semibold mb-6" style={{ color: 'var(--text-primary)' }}>
                        Sign in
                    </h2>

                    <form onSubmit={handleSubmit} className="space-y-4">
                        {error && (
                            <div className="p-3 rounded-lg text-sm" style={{
                                backgroundColor: 'rgba(239, 68, 68, 0.1)',
                                color: 'var(--danger)'
                            }}>
                                {error}
                            </div>
                        )}

                        <div>
                            <label className="label">Email</label>
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="input"
                                placeholder="admin@example.com"
                                required
                                autoFocus
                            />
                        </div>

                        <div>
                            <label className="label">Password</label>
                            <input
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="input"
                                placeholder="••••••••"
                                required
                            />
                        </div>

                        <button
                            type="submit"
                            disabled={loading}
                            className="btn btn-primary w-full"
                        >
                            {loading ? 'Signing in...' : 'Sign in'}
                        </button>
                    </form>
                </div>

                {/* Hint */}
                <p className="mt-4 text-center text-xs" style={{ color: 'var(--text-muted)' }}>
                    Use credentials from Cloudflare environment variables
                </p>
            </div>
        </div>
    );
}
